import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Button, CheckboxFieldReduxFormWrapper } from '@adc/ui-core'
import classNames from 'classnames/bind'
import {
  canAddChild,
  rulesType,
  getFormChildren,
  getChildInitialSubType,
} from '../utils'
import SubEntityForm from '../subEntityForm'
import styles from './styles.scss'
const cx = classNames.bind(styles)

// handles opening multiple sub entity forms
class MultiSubEntity extends Component {
  static propTypes = {
    fields: PropTypes.any,
    meta: PropTypes.object,
    level: PropTypes.number,
    entityType: PropTypes.string,
    showTitlesOnly: PropTypes.bool,
    formKeyPrefix: PropTypes.string,
    interestedPartiesCount: PropTypes.number,
    isAutoCapitalize: PropTypes.bool,
    isOhioAsset: PropTypes.bool,
    contentOpenedContext: PropTypes.shape({
      contentOpened: PropTypes.object.isRequired,
      deleteKey: PropTypes.func.isRequired,
      updateContentOpened: PropTypes.func.isRequired,
    }).isRequired,
    ...rulesType,
  }

  static defaultProps = {
    showTitlesOnly: false,
  }

  onAddInterestedParty = e => {
    const {
      level,
      rules,
      interestedPartiesCount,
      formKeyPrefix,
      contentOpenedContext,
    } = this.props
    const { updateContentOpened } = contentOpenedContext
    // button clicks trigger form submit
    e.preventDefault()
    e.stopPropagation()
    const subFormType = getChildInitialSubType(level, rules)
    const includeSignature = true
    const entityNameText = `Interested Party ${interestedPartiesCount + 1}`
    const nameText = `Individual ${interestedPartiesCount + 1}`
    this.props.fields.push({
      subFormType,
      includeSignature,
      entityNameText,
      nameText,
    })

    const key = `${formKeyPrefix}interestedParties[${interestedPartiesCount}]`
    updateContentOpened(key, true, true)
  }

  onSubEntityFormClose = (index, subFormKeyName) => {
    return () => {
      const { deleteKey } = this.props.contentOpenedContext
      deleteKey(subFormKeyName)
      this.props.fields.remove(index)
    }
  }

  renderSubEntityForms = () => {
    const {
      meta,
      rules,
      level,
      fields,
      entityType,
      showTitlesOnly,
      interestedParties,
      isAutoCapitalize,
      isOhioAsset,
      contentOpenedContext,
    } = this.props

    if (fields.length < 0) {
      return null
    } else {
      return (
        <div className={cx('content')}>
          {fields.map((subFormKeyName, index, fields) => (
            <SubEntityForm
              onClose={this.onSubEntityFormClose(index, subFormKeyName)}
              key={index}
              fieldArraysIndex={index}
              forms={getFormChildren(level, rules)}
              formKey={subFormKeyName}
              fields={fields}
              interestedParties={interestedParties}
              meta={meta}
              entityType={entityType}
              rules={rules}
              level={level}
              showTitlesOnly={showTitlesOnly}
              isAutoCapitalize={isAutoCapitalize}
              isOhioAsset={isOhioAsset}
              contentOpenedContext={contentOpenedContext}
            />
          ))}
        </div>
      )
    }
  }

  renderAddComponent = () => {
    const { level, rules, formKeyPrefix } = this.props
    const addMore = rules.flow[level].addMore
    const isIndividualChildType =
      addMore.childTypes.includes('Individual') &&
      addMore.childTypes.length === 1
    const elmIdType = isIndividualChildType ? 'individual' : 'interested_party'

    return addMore.type === 'button' ? (
      <div className={cx('add-button-field')}>
        <Button
          elmId={`add_${elmIdType}`}
          role='primary'
          isStretch
          onClick={this.onAddInterestedParty}
        >
          {addMore.text}
        </Button>
      </div>
    ) : (
      <a
        className={cx('add-link')}
        data-elm-id={`${formKeyPrefix}add_${elmIdType}`}
        role='primary'
        onClick={this.onAddInterestedParty}
      >
        {addMore.text}
      </a>
    )
  }

  renderMaxCheckbox = () => {
    const { formKeyPrefix, level, rules } = this.props
    const addMore = rules.flow[level].addMore
    const isParent = formKeyPrefix === 'parent.'

    return (
      <div className={cx('add-more-checkbox', isParent && 'parent-level')}>
        <Field
          name={
            isParent
              ? `${formKeyPrefix}moreEntityInvolved`
              : `${formKeyPrefix}moreIndividualInvolved`
          }
          type='checkbox'
          elmId={`${formKeyPrefix}checkbox_more_entity_involved`}
          checkboxLabel={addMore.checkboxMaxText}
          component={CheckboxFieldReduxFormWrapper}
        />
      </div>
    )
  }

  render() {
    const { level, interestedPartiesCount, rules, showTitlesOnly } = this.props
    const canAddAnotherChild = canAddChild(interestedPartiesCount, level, rules)

    return (
      <div>
        <div className={cx('root')}>
          {this.renderSubEntityForms()}
          {!showTitlesOnly && !canAddAnotherChild && this.renderMaxCheckbox()}
        </div>
        {!showTitlesOnly && canAddAnotherChild && this.renderAddComponent()}
      </div>
    )
  }
}

export default MultiSubEntity
